import { defineComponent as _defineComponent } from 'vue'
import icons from './icons/icons';

export type Icon = keyof typeof icons;

interface Props {
  name: Icon;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiIcon',
  props: {
    name: null
  },
  setup(__props: any) {



return { __sfc: true,icons }
}

})